var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jsPc6e"},[_c('div',{staticClass:"DANM4",attrs:{"jsname":"P3Vluc"}},[_c('img',{staticClass:"rYD0Re dmJ7hc",attrs:{"src":require('../assets/acampe-me-header.svg'),"alt":"camp header","aria-hidden":"true","data-atf":"true","data-iml":"844"}})]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-title"},[_c('h1',[_vm._v("Camping")])])
}]

export { render, staticRenderFns }